
import { useEffect, useState } from 'react';
import Card from './components/Card';
import CartIcon from './components/CartIcon';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules'
import dayjs from 'dayjs';
declare global {
    interface Window { siteVar: any; }
};
// Import Swiper styles
import 'swiper/swiper-bundle.css';
const {VITE_EXPRESS_API} = import.meta.env
const domain = window.siteVar.referer

type Brochure = {
  br_cdn : string,
  br_name : string,
  br_year : string,
  br_code : string,
  br_launch : string,
  br_description? : string
}

const App = () => {

  const [ brochures, setBrochures ] = useState<Brochure[]|[]>([])
  const [ selection, setSelection ] = useState<string[]|[]|any>([])
  const [ maxOrderError, setMaxOrderError ] = useState(false)

  const fetchBrochures = async() => {
  const url = `${VITE_EXPRESS_API}/brochures/${domain}`
  const res = await fetch(url)
  const brochures = await res.json()

  if(brochures){
    setBrochures(brochures)
  }else{
    setBrochures([])
  }
}

useEffect(() => {
fetchBrochures()
},[])

  return (
    <>
     <section className='w-100 overflow-hidden'>
        <div className='container-fluid my-5 flex-column justify-content-center align-items-center overflow-hidden p-0'>
        <h3 className='section-heading text-center'>Order a FREE Brochure</h3>
        <p className='text-center'>You can order up to 3 brochures at a time</p>
        <span className='h-1rem d-block'>
      {maxOrderError &&
        <p className='text-danger text-center'>Maximum 3 brochures reached...</p>
      }
        </span>
     
        <div className='container-fluid position-relative p-0'>
          {/* navigation buttons */}
          <div className='container-fluid d-flex justify-content-end text-dark mb-3 '>
         
            
            <span className='d-none d-lg-flex'>
            <i id="swiperBack" className='icon-chevron_left glyph-md p-3 me-3' role="button"></i>
            <i id="swiperForward" className='icon-chevron_right glyph-md p-3' role="button"></i>
            </span>

          </div>
        <Swiper
        slidesPerView={3}
        spaceBetween={10}
        loop={true}
        modules={[Navigation, Pagination]}
        className="mySwiper"
        navigation={{nextEl : '#swiperForward', prevEl : '#swiperBack'}}
        breakpoints={{
          640: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 50,
          },
          2480: {
            slidesPerView: 7,
            spaceBetween: 60,
          }
        }}
      >
       {brochures && brochures.length && brochures.map((brochure:Brochure, index:number) => {
     if(brochure.br_name !== 'Trailfinder magazine' && brochure.br_name !== 'Trailfinders Travel Insurance'){
      return (
<SwiperSlide>
    <div  key={'brochure_' + index} 
          onClick={() => {
            if( selection.length < 3 || selection.includes(brochure.br_code) ){
              setMaxOrderError(false)
            let tmp = [...selection]
            tmp.includes(brochure.br_code) ? tmp.splice(tmp.indexOf(brochure.br_code), 1) : tmp.push(brochure.br_code)
            setSelection([...tmp])
            }else{
              setMaxOrderError(true)
            }

          }}>
      <Card image={brochure.br_cdn}  
            isPreOrder={new Date() < new Date(brochure.br_launch)} 
            isNew = { dayjs().diff(dayjs(brochure.br_launch),'day') < 14 }
            isSelected = { selection.includes(brochure.br_code)}
            description={brochure.br_description? brochure.br_description : ''} 
            name={brochure.br_name}
            launch={dayjs(brochure.br_launch).format('DD MMM YY')}/>
    </div>
  </SwiperSlide>
  )
}
})}
  {/* the left and right gradients */}
          <span className='position-absolute top-0 fadeOut h-100 pointer-events-none'></span>
          <span className='position-absolute top-0 fadeOutL h-100 pointer-events-none'></span>
          </Swiper>
        </div>
        
      </div>

      <div className='col col-12 col-md-4 col-xl-3 p-3 mx-auto'>
        <a href={`/brochures/brochure-request-form?order=${selection.join('')}`}>
          <button className='btn btn-outline-dark p-3 rounded-0 w-100 brolink' data-ga4-category="button_carousel" data-ga4-label={`home - ${selection}`}>
                Complete your Order <i className='icon-arrow_right glyph-sm'></i>
          </button>
        </a>
      </div>

      <div className='container-fluid min-h-4rem'>
        { selection.length ? 
        (
          <><span className='p-3 bg-light'> 
              <small>your orders</small>
                 <CartIcon orders={selection.length}/>
                :
             </span>
             {brochures && brochures.map((brochure:Brochure, index) => {
              if(selection.includes(brochure.br_code)){
                return (
                  <span className='ms-3 position-relative' key={'pillbtn-' + index}>
                    <button className='btn btn-light p-3 rounded-pill' 
                            title={brochure.br_name} 
                            aria-label={brochure.br_name}
                            onClick={() => {
                            setMaxOrderError(false)
                            let tmp = [...selection]
                            tmp.splice(tmp.indexOf(brochure.br_code), 1)
                            setSelection([...tmp])
                    }}>
                      
                      <span className='me-3' >
                        <svg height="25" width="25" xmlns="http://www.w3.org/2000/svg">
                         <path fill='#bcbbbbff' d="M8.4,17l3.6-3.6,3.6,3.6,1.4-1.4-3.6-3.6,3.6-3.6-1.4-1.4-3.6,3.6-3.6-3.6-1.4,1.4,3.6,3.6-3.6,3.6,1.4,1.4ZM12,22c-1.4,0-2.7-.3-3.9-.8s-2.3-1.2-3.2-2.1-1.6-2-2.1-3.2-.8-2.5-.8-3.9.3-2.7.8-3.9,1.2-2.3,2.1-3.2,2-1.6,3.2-2.1,2.5-.8,3.9-.8,2.7.3,3.9.8,2.3,1.2,3.2,2.1,1.6,2,2.1,3.2.8,2.5.8,3.9-.3,2.7-.8,3.9-1.2,2.3-2.1,3.2-2,1.6-3.2,2.1-2.5.8-3.9.8ZM12,20c2.2,0,4.1-.8,5.7-2.3s2.3-3.4,2.3-5.7-.8-4.1-2.3-5.7-3.4-2.3-5.7-2.3-4.1.8-5.7,2.3-2.3,3.4-2.3,5.7.8,4.1,2.3,5.7,3.4,2.3,5.7,2.3Z"/>
                        </svg>
                      </span>
                      <span>{brochure.br_name.length > 20 ? brochure.br_name.substring(0,20) + '...' : brochure.br_name}</span>
                      </button>
                  </span>
                )
              }
             }) 

             }</>
        ) : ('') 
      }
             
           
        </div>
  </section>
</>
  )
}

export default App
